/**
 * Tells if a section already holds another resource with the name. The check
 * ignores letter case and the spaces at the ends, the same as the section
 * name check and the service rule. The resource under edit can keep its own
 * name.
 */
export function resourceNameTaken(
  title: string,
  categoryId: number | null,
  resources: { id: number; title: string; resourceCategoryId: number }[],
  ownId?: number | null
): boolean {
  const wanted = title.trim().toLowerCase();
  if (wanted.length === 0 || categoryId === null) {
    return false;
  }

  return resources.some(
    (resource) =>
      resource.id !== ownId &&
      resource.resourceCategoryId === categoryId &&
      resource.title.trim().toLowerCase() === wanted
  );
}
